import * as _ from 'lodash';
import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output
} from '@angular/core';

@Directive({
  selector: '[appCalcEllipsisSize]'
})
export class CalcEllipsisSizeDirective implements OnChanges {
  @HostListener('window:resize', [])
  onResize = _.throttle(this.setEllipsis, 100, {
    leading: true,
    trailing: true
  });

  @Input()
  resize: boolean;

  @Output()
  onEllipsisSize: EventEmitter<number> = new EventEmitter<number>();

  constructor(private el: ElementRef) {}

  ngOnChanges(changesObj) {
    if (_.get(changesObj, 'resize.currentValue')) {
      this.setEllipsis();
    }
  }

  private setEllipsis() {
    const width = this.el.nativeElement.clientWidth;

    if (width) {
      this.onEllipsisSize.emit(width / 10);
    }
  }
}
